<nav class="navbar navbar-expand-lg nav-bar-bg">
  <div class="container-fluid px-md-5">
    <a class="navbar-brand" [routerLink]="['/home']">
      <img src="assets/images/logos/kenindia-logo.png" alt="Bootstrap" width="110" height="62">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo01"
      aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
      <!-- <span class="navbar-toggler-icon"></span> -->
      <span>
        <i class="fa fa-bars" aria-hidden="true"></i>
      </span>
    </button>
    <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" [routerLink]="['/quotation/get-quote']"><i
              class="fa-solid fa-quote-right"></i> Get Quote</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/quotation/my-quotation']"><i class="fa-regular fa-newspaper"></i> My
            Quotaions</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" aria-disabled="true" [routerLink]="['/policy/my-policy']"><i
              class="fa-solid fa-shield"></i> My Policy</a>
        </li>
        <!-- <li class="nav-item">
            <a class="nav-link" aria-disabled="true"  [routerLink]="['/policy/my-policy']"><i class="fa-regular fa-file-lines"></i> Modify Policy</a>
          </li> -->
        <!-- <li class="nav-item">
            <a class="nav-link" aria-disabled="true"><i class="fa-solid fa-user"></i> Profile</a>
          </li> -->
        <li class="nav-item dropdown">
          <a class="nav-link" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
            aria-expanded="false">
            <i class="fa-solid fa-user"></i> Profile
          </a>

          <ul class="dropdown-menu py-4 px-3" aria-labelledby="navbarDropdown">
            <ng-container *ngIf="tokenStorageService.isAuthenticated()">
              <!-- <li class="dropdown-item dropdown-item-text"><strong>Customer ID :</strong> AD0002983</li> -->
               <li class="profile-info p-2">
                        <div>
                            <span class="name">{{userDetail?.fullName || ''}} : </span><span class="name">{{userDetail?.phoneNumber}}</span>
                        </div>
                        <img src="assets/images/profiles/myprofile.png" alt="">
                    </li>
              <li class="dropdown-item">
                <button class="secondary-Button mt-4 w-100" (click)="logout()">Sign Out</button>
              </li>
            </ng-container>
            <ng-container *ngIf="!tokenStorageService.isAuthenticated()">
              <li class="dropdown-item dropdown-item-text">Log in to access more benefits!</li>
              <li class="dropdown-item">
                <button class="secondary-Button mt-4 w-100" (click)="logIn()">Log In</button>
              </li>
            </ng-container>

          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>